import { FC } from 'react';

import { Icon } from '../../../shared/ui';
import { IconMap } from '../../../shared/sprite';

export const SearchModalEmpty: FC = () => {
  return (
    <div className="w-full h-full flex flex-col items-center justify-center gap-y-4 text-center">
      <div className="relative flex-shrink-0 p-3 rounded-[10px] border border-gray-200 bg-white shadow-xs">
        <Icon
          glyph={IconMap.TextInput}
          width={24}
          height={24}
          className="text-gray-700"
        />
      </div>
      <div className="flex flex-col items-center justify-center gap-y-1 max-w-88">
        <p className="font-semibold text-gray-900 text-md">
          Start typing to search
        </p>
        <p className="text-gray-600 text-sm">
          Please enter the name of the item you want to find and select it from
          the list to preview.
        </p>
      </div>
    </div>
  );
};
